module.exports = __webpack_public_path__ + "media/images/icons/rarr_red-caf19f4d29128176ba4da9552c6be378.svg";